export default {
  SET_SITES_STATEMENT: function (state, payloads) {
    state.statementsOfNotSellingSites = payloads;
  }
}
